var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectivePerformanceEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #263238;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-4, .cls-11, .cls-5, .cls-6, .cls-12, .cls-7, .cls-8, .cls-13, .cls-9, .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-14 {\n        opacity: .3;\n      }\n\n      .cls-4, .cls-12 {\n        opacity: .2;\n      }\n\n      .cls-15 {\n        fill: #f0f0f0;\n      }\n\n      .cls-11, .cls-6 {\n        opacity: .4;\n      }\n\n      .cls-5, .cls-16 {\n        opacity: .6;\n      }\n\n      .cls-17 {\n        fill: #e0e0e0;\n      }\n\n      .cls-18 {\n        fill: #c95b1f;\n      }\n\n      .cls-19 {\n        fill: #407bff;\n      }\n\n      .cls-20 {\n        fill: #e4897b;\n      }\n\n      .cls-21 {\n        fill: #a24e3f;\n      }\n\n      .cls-22 {\n        fill: #ff9b64;\n      }\n\n      .cls-23 {\n        fill: #ff6500;\n      }\n\n      .cls-7, .cls-13, .cls-24 {\n        opacity: .5;\n      }\n\n      .cls-8, .cls-25 {\n        opacity: .7;\n      }\n\n      .cls-26 {\n        fill: #ebebeb;\n      }\n\n      .cls-27 {\n        fill: #de5753;\n      }\n\n      .cls-28 {\n        fill: #f5f5f5;\n      }\n\n      .cls-29 {\n        fill: #fafafa;\n      }\n\n      .cls-9 {\n        opacity: .8;\n      }\n\n      .cls-30 {\n        fill: #b97964;\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-10 {\n        opacity: .9;\n      }\n\n      .cls-32 {\n        fill: #e6e6e6;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 440.78,
    y1: 395.34,
    x2: 1052.03,
    y2: 395.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7c8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#aeccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c0d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ccdfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0e2ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1126.56,
    y: 891.35,
    width: 76.59,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 908.61,
    y: 897.64,
    width: 20.1,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1079.87,
    y: 869.89,
    width: 44.38,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 284.09,
    y: 873.78,
    width: 99.87,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 404.57,
    y: 873.78,
    width: 14.64,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 466.8,
    y: 883.54,
    width: 216.63,
    height: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M710.83,751.01h-446.49c-7.29,0-13.2-5.91-13.2-13.2V110.14c.06-7.25,5.96-13.09,13.2-13.09h446.49c7.29,0,13.2,5.91,13.2,13.2h0v627.55c0,7.29-5.91,13.2-13.2,13.2ZM264.35,97.52c-6.97.01-12.61,5.66-12.63,12.63v627.66c.01,6.97,5.66,12.61,12.63,12.63h446.49c6.97-.01,12.61-5.66,12.63-12.63V110.14c-.01-6.97-5.66-12.61-12.63-12.63h-446.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1211.03,751.01h-446.53c-7.29-.01-13.19-5.92-13.2-13.2V110.14c.08-7.24,5.96-13.08,13.2-13.09h446.53c7.23.03,13.09,5.86,13.16,13.09v627.66c0,7.27-5.88,13.18-13.16,13.2ZM764.5,97.52c-6.97.01-12.61,5.66-12.63,12.63v627.66c.01,6.97,5.66,12.61,12.63,12.63h446.53c6.97-.01,12.61-5.66,12.63-12.63V110.14c-.01-6.97-5.66-12.61-12.63-12.63h-446.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 162.78,
    y: 854.15,
    width: 1156.22,
    height: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M530.81,645.1h14.38v208.97c0,1.52-1.23,2.75-2.75,2.75h-8.9c-1.52,0-2.75-1.23-2.75-2.75h0v-208.97h.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 851.66,
    y: 626.3,
    width: 124.78,
    height: 18.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M620,645.1h14.38v208.97c0,1.52-1.23,2.75-2.75,2.75h-8.9c-1.52,0-2.75-1.23-2.75-2.75h0v-208.97h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M953.64,645.1h14.38v208.97c0,1.52-1.23,2.75-2.75,2.75h-8.9c-1.52,0-2.75-1.23-2.75-2.75h0v-208.97h.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 522.48,
    y: 626.3,
    width: 364.76,
    height: 18.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M864.52,645.1h14.38v208.97c0,1.52-1.23,2.75-2.75,2.75h-8.9c-1.52,0-2.75-1.23-2.75-2.75h0v-208.97h.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1102.23,
    y: 471.72,
    width: 6.1,
    height: 382.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1173.73,432.17c0,19.52-13.87,36.54-34.39,45.6h-68.1c-20.49-9.06-34.36-26.08-34.36-45.6s13.87-36.51,34.39-45.58h68.1c20.53,9.06,34.36,26.08,34.36,45.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1072.13,476.29c-17.6-8.26-33.53-23.31-33.53-44.1s15.96-35.82,33.53-44.1c2.01-.95.25-3.93-1.76-2.98-18.68,8.79-35.24,25.14-35.24,47.08s16.53,38.32,35.24,47.1c2.01.92,3.77-2.06,1.76-3.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1087.04,385.37c-24.12,23.12-24.12,70.58,0,93.63,1.62,1.55,4.07-.9,2.45-2.45-22.75-21.74-22.78-67.06,0-88.73,1.62-1.55-.83-4-2.45-2.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1103.58,386.59v91.18c0,.96.78,1.73,1.73,1.73s1.73-.78,1.73-1.73v-91.18c0-.96-.78-1.73-1.73-1.73s-1.73.78-1.73,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1121.1,387.82c22.75,21.74,22.78,67.06,0,88.73-1.62,1.55.83,4,2.45,2.45,24.12-23.12,24.12-70.6,0-93.63-1.62-1.55-4.07.9-2.45,2.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1138.47,388.07c17.6,8.28,33.53,23.31,33.53,44.1s-15.96,35.84-33.53,44.1c-2.01.95-.25,3.93,1.76,3.01,18.68-8.79,35.24-25.14,35.24-47.1s-16.53-38.29-35.24-47.08c-2.01-.95-3.77,2.03-1.76,2.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1062.32,856.83h85.79c0-5.79-4.69-10.48-10.48-10.48h-64.77c-5.77,0-10.45,4.68-10.45,10.45v.02h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M426.82,686.96c.21.28-1.25,1.85,3.88,1.71,12.7-.32,34.99-2.68,42.62-14.73,10.89-17.23-16.67-13.87-14.59-23.12,2.08-9.25,32.37-3.84,37.23-17.14,4.86-13.3-16.51-9.25-15.96-16.07.55-6.82,23.79.39,30.36-13.87,6.57-14.27-12.76-5.55-9.94-11.45,2.82-5.9,26.38-31.22,15.84-35.8-10.54-4.58-32.49,21.67-40.12,24.84-7.63,3.17-11.03-20.81-20.81-12.14-9.78,8.67-.53,44.88-12.16,50.23-8.67,3.98-4.62-9.43-15.66-8.21-14.75,1.76-16.23,53.32-.69,75.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M474.52,617.03c-3.71-.18-7.42.11-11.05.88,2.74-3.18,5.7-6.14,8.88-8.88.41-.31.49-.89.18-1.3,0,0-.01-.02-.02-.02-.33-.4-.91-.46-1.32-.14-6.85,5.99-12.93,12.82-18.08,20.33-.28-15.35,3.72-30.46,11.56-43.66.21-.33.12-.76-.21-.97-.33-.21-.76-.12-.97.21h0c-.14.21-13.41,20.81-11.7,46.25-1.54,2.27-3.14,4.72-4.79,7.35-5.69,9.37-10.5,19.26-14.34,29.53-3.52-9.26-4.85-19.21-3.86-29.07.04-.38-.24-.72-.62-.76,0,0,0,0,0,0-.38-.04-.72.24-.76.62,0,0,0,0,0,0-1.07,10.58.52,21.27,4.62,31.08-7.3,20.26-11.54,41.49-12.58,62.99-.03.51.37.95.88.97,0,0,0,0,0,0h.12c.47-.03.85-.41.88-.88,1.16-27.3,7.77-54.1,19.45-78.81,4.35-3.92,9.9-6.24,15.75-6.57.38-.02.68-.33.69-.72-.01-.38-.33-.68-.72-.67h0c-5.14.23-10.1,1.97-14.27,4.99,5.38-10.75,11.99-20.84,19.7-30.06,4.09-1.15,8.34-1.61,12.58-1.36.39.01.72-.28.74-.67-.04-.38-.36-.67-.74-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M392.29,695.47c-14.31.28-38.76-13.02-48.35-25.95-9.6-12.93,17.71-4.99,14.85-15.17-2.87-10.17-36.58-2.68-42.83-17.46s18.15-11.35,17.18-18.89c-.97-7.54-26.22-6.01-34.32-21.69-8.09-15.68,14.11-6.94,10.61-13.41-3.49-6.47-31.31-33.85-19.68-39.57,11.63-5.71,37.74,22.68,46.46,25.85,8.72,3.17,10.8-16.49,22.18-7.08,11.38,9.41,2.84,50.57,16.19,55.98,9.99,4.05,5.73-14.8,17.23-10.04,20.16,8.32,6.29,87.29.49,87.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M392.29,695.47c-14.31.28-38.76-13.02-48.35-25.95-9.6-12.93,17.71-4.99,14.85-15.17-2.87-10.17-36.58-2.68-42.83-17.46s18.15-11.35,17.18-18.89c-.97-7.54-26.22-6.01-34.32-21.69-8.09-15.68,14.11-6.94,10.61-13.41-3.49-6.47-31.31-33.85-19.68-39.57,11.63-5.71,37.74,22.68,46.46,25.85,8.72,3.17,10.8-16.49,22.18-7.08,11.38,9.41,2.84,50.57,16.19,55.98,9.99,4.05,5.73-14.8,17.23-10.04,20.16,8.32,6.29,87.29.49,87.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M387.58,678.29c.22-.07.4-.22.51-.42,5.45-12.01,7.66-25.24,6.41-38.36-.04-.52-.49-.92-1.02-.88-.52.04-.92.49-.88,1.02,1.07,12.45-.92,24.97-5.8,36.47-5.92-15.97-13.2-31.4-21.78-46.11,2.52-30.71-13.23-55.89-13.39-56.12-.25-.46-.83-.62-1.29-.37-.46.25-.62.83-.37,1.29.02.04.04.07.06.1,9.11,15.84,13.7,33.88,13.25,52.15-10.29-17.68-22.57-34.12-36.61-49-.48-.5-1.27-.52-1.77-.04-.01.01-.03.03-.04.04-.5.5-.5,1.3,0,1.8,0,0,0,0,0,0,10.38,10.93,19.74,22.79,27.96,35.43-8.64-3.29-17.81-4.93-27.06-4.86-.52,0-.95.42-.95.95,0,0,0,.02,0,.02.01.53.44.95.97.95h0c9.93-.08,19.77,1.86,28.93,5.71,5.66,8.65,10.86,17.59,15.59,26.78-7.8-5.37-17.56-7.06-26.71-4.62-.51.15-.8.67-.67,1.18.12.5.62.8,1.12.68.01,0,.03,0,.04-.01,9.96-2.56,20.54,0,28.23,6.82,16.56,32.63,26.02,68.39,27.75,104.94.04.68.59,1.21,1.27,1.23h0c.71-.04,1.25-.63,1.23-1.34-1.11-25.75-6.16-51.19-14.98-75.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M434.84,856.83c11.1-31.59,18.38-77.24,18.38-97.24.31-15.37-4.45-30.41-13.55-42.8h-56.77c-9.09,12.37-13.85,27.39-13.55,42.73,0,20,7.28,65.65,18.5,97.24l46.99.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M406.24,688.41c.18.16-.55,1.5,2.98.55,8.74-2.31,23.79-7.68,27.08-17.3,4.62-13.76-13.87-6.94-13.87-13.57s21.71-8.05,22.92-18.08c1.2-10.04-12.97-3.72-13.71-8.46-.74-4.74,16.56-3.7,18.73-14.64,2.17-10.94-9.76-1.73-8.79-6.29.97-4.56,13.09-26.01,5.02-27.45-8.07-1.43-18.92,20.44-23.66,23.91-4.74,3.47-11.15-12.67-16.4-4.97-5.25,7.7,7.1,31.19,0,36.84-5.34,4.19-4.83-5.78-12.21-3.1-10.15,3.65-2.61,39.61,11.91,52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M427.65,632.04c-2.59.48-5.11,1.31-7.49,2.45,1.34-2.66,2.89-5.21,4.62-7.63.24-.27.24-.68,0-.95-.29-.22-.7-.17-.92.12-3.79,5.29-6.9,11.04-9.25,17.11-2.75-10.59-2.48-21.74.76-32.19.09-.25-.04-.53-.29-.62,0,0,0,0,0,0-.26-.09-.55.04-.65.3-3.41,11.06-3.55,22.86-.42,33.99-.69,1.83-1.41,3.79-2.08,5.87-2.38,7.44-4.06,15.09-5.02,22.85-4.01-5.81-6.58-12.49-7.52-19.49-.05-.27-.3-.46-.58-.42-.26.06-.43.29-.42.55,1.01,7.51,3.86,14.66,8.3,20.81-1.67,15.25-1.07,30.67,1.78,45.74.08.36.42.59.79.53h0c.32-.11.51-.43.46-.76-3.73-19.1-3.62-38.76.35-57.81,2.36-3.45,5.83-5.98,9.83-7.17.27-.08.42-.36.35-.62-.08-.26-.34-.41-.6-.35-3.53,1.01-6.67,3.05-9.04,5.85,2-8.37,4.97-16.48,8.86-24.17,2.65-1.46,5.51-2.48,8.49-3.03.25-.03.44-.26.41-.51,0-.02,0-.04-.01-.06-.02-.27-.26-.46-.53-.44-.06,0-.11.02-.17.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 561.26,
    y: 657.24,
    width: 150.01,
    height: 199.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 711.27,
    y: 657.24,
    width: 28.6,
    height: 199.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 571.78,
    y: 672.06,
    width: 129.75,
    height: 48.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M619.74,672.06l.55,6.45c.19,2.13,1.98,3.77,4.12,3.77h24.49c2.14-.01,3.91-1.64,4.12-3.77l.55-6.45h-33.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 571.78,
    y: 725.83,
    width: 129.75,
    height: 48.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M619.74,725.83l.55,6.45c.19,2.13,1.98,3.77,4.12,3.77h24.49c2.14-.01,3.91-1.64,4.12-3.77l.55-6.45h-33.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 571.78,
    y: 779.59,
    width: 129.75,
    height: 48.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M619.74,779.59l.55,6.45c.19,2.13,1.98,3.77,4.12,3.77h24.49c2.1,0,3.86-1.57,4.12-3.65l.55-6.45-33.83-.12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-170"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-170",
    className: "cls-28",
    cx: 729.75,
    cy: 923.5,
    rx: 448.36,
    ry: 26.18
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 440.78,
    y: 169.8,
    width: 611.25,
    height: 451.06,
    rx: 8.97,
    ry: 8.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 440.78,
    y: 169.8,
    width: 611.25,
    height: 451.06,
    rx: 8.97,
    ry: 8.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M559.9,169.8h-107.67c-6.39,0-11.56,5.18-11.56,11.56v428.08c.06,6.34,5.22,11.45,11.56,11.45h107.67V169.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.61,169.8H452.23c-6.39,0-11.56,5.18-11.56,11.56v29.83h611.36v-29.95c-.06-6.29-5.14-11.37-11.42-11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M460.76,184.46c-1.1.12-2.1-.68-2.22-1.78-.12-1.1.68-2.1,1.78-2.22.14-.02.29-.02.43,0h15.75c1.1.12,1.9,1.11,1.78,2.22-.1.94-.84,1.68-1.78,1.78h-15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M460.76,192.44c-1.1.12-2.1-.68-2.22-1.78-.12-1.1.68-2.1,1.78-2.22.14-.02.29-.02.43,0h15.75c1.1.12,1.9,1.11,1.78,2.22-.1.94-.84,1.68-1.78,1.78h-15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M460.76,200.44c-1.1.12-2.1-.68-2.22-1.78-.12-1.1.68-2.1,1.78-2.22.14-.02.29-.02.43,0h15.75c1.1.12,1.9,1.11,1.78,2.22-.1.94-.84,1.68-1.78,1.78h-15.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 580.94,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 645.34,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 709.74,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 774.15,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 838.55,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 902.95,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 967.35,
    y: 237.63,
    width: 51.52,
    height: 142.77,
    rx: 5.06,
    ry: 5.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.32,467.92h-1.85v2.31h-2.64v-2.31h-6.06v-1.76l5.32-7.15h2.73l-4.93,6.78h3.03v-2.1h2.45v2.1h1.85l.09,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.43,464.2c.76.62,1.18,1.56,1.13,2.54.01.66-.16,1.31-.51,1.87-.39.59-.93,1.06-1.57,1.36-.82.35-1.7.51-2.59.49-.78,0-1.56-.1-2.31-.3-.7-.18-1.36-.48-1.94-.9l1.02-1.99c.44.33.95.58,1.48.74.56.19,1.15.28,1.73.28.54.02,1.08-.11,1.55-.39.36-.24.57-.65.55-1.09.02-.44-.2-.85-.58-1.09-.64-.3-1.35-.43-2.06-.37h-2.87l.58-6.34h6.94v2.08h-4.62l-.18,2.15h.92c1.18-.05,2.35.28,3.33.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.07,464.25c-1.05-1.32-1.05-3.19,0-4.51,1.07-1.11,2.85-1.14,3.96-.07.02.02.05.04.07.07,1.01,1.33,1.01,3.18,0,4.51-1.07,1.11-2.85,1.14-3.96.07-.02-.02-.05-.04-.07-.07ZM728.94,463.32c.24-.4.35-.86.32-1.32.03-.47-.08-.94-.32-1.34-.19-.29-.51-.47-.86-.46-.35,0-.67.17-.86.46-.24.4-.35.87-.32,1.34-.03.46.09.92.32,1.32.19.29.51.46.86.46.35,0,.67-.17.86-.46ZM734.79,459.02h1.92l-7.7,11.26h-1.99l7.77-11.26ZM734.28,470.03c-.43-.26-.76-.64-.97-1.09-.26-.51-.39-1.07-.37-1.64-.01-.57.11-1.13.37-1.64.21-.45.55-.82.97-1.09.44-.25.95-.38,1.46-.37.76-.03,1.49.28,2.01.83.56.64.84,1.47.79,2.31.06.85-.22,1.68-.79,2.31-.51.57-1.25.88-2.01.86-.52-.02-1.03-.19-1.46-.49ZM736.59,468.64c.23-.41.34-.87.3-1.34.03-.46-.07-.92-.3-1.32-.33-.47-.98-.59-1.45-.26-.1.07-.19.16-.26.26-.24.4-.35.87-.32,1.34-.04.47.07.94.32,1.34.19.29.51.47.86.46.35,0,.67-.19.86-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.07,463.64c.56.29,1.03.71,1.39,1.23.34.55.52,1.2.51,1.85.02.7-.18,1.4-.55,1.99-.38.57-.91,1.02-1.53,1.32-.68.3-1.43.45-2.17.44-1.38.09-2.74-.44-3.7-1.43-.96-1.16-1.44-2.64-1.34-4.14-.02-1.14.22-2.26.72-3.28.45-.89,1.16-1.62,2.03-2.08.93-.49,1.96-.73,3.01-.72.58,0,1.17.07,1.73.21.49.11.96.31,1.39.58l-.95,1.92c-.63-.41-1.38-.61-2.13-.58-.85-.06-1.69.25-2.31.83-.59.68-.92,1.55-.9,2.45.75-.71,1.77-1.08,2.8-1.02.7,0,1.38.14,2.01.44ZM888.93,468.08c.68-.68.68-1.77,0-2.45-.4-.33-.9-.49-1.41-.46-.5-.01-.99.15-1.39.46-.67.59-.73,1.61-.14,2.28.04.05.09.1.14.14.84.6,1.98.6,2.82,0l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.31,464.2c.75.63,1.16,1.57,1.13,2.54,0,.66-.17,1.31-.51,1.87-.39.59-.93,1.06-1.57,1.36-.83.35-1.72.51-2.61.49-.78,0-1.56-.1-2.31-.3-.7-.18-1.37-.49-1.97-.9l1.04-1.99c.44.34.94.59,1.48.74.55.18,1.13.28,1.71.28.54.03,1.08-.11,1.55-.39.37-.23.59-.65.58-1.09,0-.44-.22-.86-.6-1.09-.63-.3-1.34-.43-2.03-.37h-2.87l.58-6.34h6.94v2.08h-4.62l-.18,2.15h.92c1.19-.06,2.37.28,3.35.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.93,464.25c-1.01-1.33-1.01-3.18,0-4.51,1.09-1.12,2.87-1.14,3.99-.06.02.02.04.04.06.06,1.01,1.33,1.01,3.18,0,4.51-1.09,1.12-2.87,1.14-3.99.06-.02-.02-.04-.04-.06-.06ZM905.82,463.32c.23-.4.33-.86.3-1.32.04-.47-.07-.93-.3-1.34-.3-.47-.93-.61-1.41-.3-.12.08-.23.18-.3.3-.24.4-.35.87-.32,1.34-.03.46.09.92.32,1.32.3.47.93.61,1.41.3.12-.08.23-.18.3-.3ZM911.67,459.02h1.92l-7.7,11.26h-1.92l7.7-11.26ZM911.16,470.03c-.43-.26-.77-.64-.99-1.09-.24-.51-.36-1.08-.35-1.64-.01-.57.11-1.13.35-1.64.23-.44.57-.82.99-1.09,1.13-.63,2.54-.44,3.47.46.55.64.83,1.47.79,2.31.05.84-.23,1.67-.79,2.31-.52.57-1.26.88-2.03.86-.51-.02-1.01-.19-1.43-.49ZM913.47,468.64c.23-.41.34-.87.3-1.34.03-.46-.07-.92-.3-1.32-.19-.3-.53-.47-.88-.46-.33,0-.64.17-.83.44-.24.4-.35.87-.32,1.34-.04.47.07.94.32,1.34.18.29.49.46.83.46.35,0,.69-.17.88-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.87,398.23v11.28h-2.61v-9.25h-2.31v-2.1l4.93.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.46,398.23h5.11c1.12-.03,2.23.22,3.24.72.91.43,1.67,1.11,2.2,1.97,1.05,1.83,1.05,4.09,0,5.92-.53.85-1.29,1.54-2.2,1.97-1.01.5-2.12.74-3.24.72h-5.11v-11.28ZM609.43,407.36c.99.05,1.96-.29,2.71-.95,1.36-1.42,1.36-3.67,0-5.09-.74-.66-1.71-1.01-2.71-.95h-2.31v6.94l2.31.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.56,398.23v11.28h-2.61v-9.25h-2.31v-2.1l4.93.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.27,398.23l-3.68,11.28h-2.82l-2.47-7.63-2.54,7.63h-2.8l-3.7-11.28h2.71l2.54,7.93,2.66-7.93h2.31l2.59,8,2.61-8h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.63,398.23v11.28h-2.61v-9.25h-2.31v-2.1l4.93.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.56,409.51v-6.78l-3.33,5.57h-1.18l-3.28-5.41v6.61h-2.45v-11.28h2.15l4.23,6.94,4.14-6.94h2.15v11.28h-2.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 778.98,
    y: 391.29,
    width: 41.86,
    height: 25.76,
    rx: 9.25,
    ry: 9.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M795.63,403.91c.52.59.8,1.36.79,2.15,0,.64-.19,1.27-.53,1.8-.37.59-.91,1.05-1.55,1.32-.81.36-1.7.54-2.59.51-.78,0-1.56-.1-2.31-.32-.7-.17-1.37-.46-1.97-.88l1.02-2.01c.45.34.95.59,1.48.76.56.18,1.15.26,1.73.25.54.03,1.08-.1,1.55-.37.36-.23.57-.64.55-1.06,0-.92-.69-1.39-2.1-1.39h-1.18v-1.73l2.31-2.61h-4.81v-2.1h7.89v1.76l-2.54,2.91c.85.09,1.64.44,2.27,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M808.58,409.51v-6.78l-3.31,5.57h-1.18l-3.31-5.41v6.61h-2.43v-11.28h2.15l4.21,6.94,4.16-6.94h2.15v11.28h-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.52,402.87c.57.27,1.05.7,1.39,1.23.36.55.54,1.19.53,1.85,0,1.41-.82,2.7-2.1,3.28-.68.31-1.42.47-2.17.46-1.39.08-2.74-.46-3.7-1.46-.97-1.15-1.45-2.64-1.34-4.14-.03-1.14.23-2.27.74-3.28.44-.88,1.15-1.59,2.01-2.06.92-.5,1.96-.74,3.01-.72.58,0,1.17.07,1.73.21.5.11.97.29,1.41.55l-.97,1.92c-.63-.39-1.36-.58-2.1-.55-.85-.05-1.69.25-2.31.83-.6.67-.92,1.53-.9,2.43.76-.7,1.77-1.06,2.8-.99.69-.01,1.37.14,1.99.44ZM858.39,407.29c.35-.31.54-.76.51-1.23.02-.46-.16-.91-.51-1.23-.4-.32-.9-.49-1.41-.46-.51-.02-1,.16-1.39.49-.36.29-.57.74-.55,1.2-.01.47.18.91.53,1.23.42.31.93.48,1.46.46.5.02.98-.15,1.36-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.35,409.51v-6.78l-3.31,5.57h-1.18l-3.31-5.41v6.61h-2.45v-11.28h2.17l4.21,6.94,4.16-6.94h2.13v11.28h-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.1,398.23v11.28h-2.61v-9.25h-2.31v-2.1l4.93.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.17,405.51v4h-2.66v-4.02l-4.35-7.26h2.75l3.03,5.02,3.01-5.02h2.57l-4.35,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.17,403.91c.52.59.8,1.36.79,2.15,0,.64-.19,1.27-.53,1.8-.38.59-.93,1.05-1.57,1.32-.8.37-1.68.54-2.57.51-.78,0-1.56-.11-2.31-.32-.7-.17-1.36-.47-1.94-.88l1.02-2.01c.45.34.95.59,1.48.76.56.18,1.15.26,1.73.25.54.03,1.08-.1,1.55-.37.36-.23.57-.64.55-1.06,0-.92-.69-1.39-2.1-1.39h-1.25v-1.73l2.31-2.61h-4.81v-2.1h7.89v1.76l-2.54,2.91c.86.08,1.67.43,2.31,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.1,405.51v4h-2.59v-4.02l-4.37-7.26h2.77l3.01,5.02,3.01-5.02h2.57l-4.39,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M574.4,338.52h0c-.26-1.76.95-3.39,2.7-3.65,0,0,0,0,0,0l60.84-9.25,64.75-26.89,65.16-8.69,63.94,22.38,63.87-27.75h64.54l60.86-20.28c1.68-.56,3.5.35,4.07,2.03,0,0,0,0,0,0h0c.56,1.68-.35,3.5-2.03,4.07,0,0,0,0,0,0l-61.67,20.81h-64.24l-64.96,28.14-64.86-22.71-63.22,8.44-64.75,26.89-61.21,9.25c-1.77.31-3.46-.88-3.77-2.65,0-.05-.02-.1-.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.99,352.67l-63.04-51.47c-1.4-1.13-1.62-3.18-.5-4.58.01-.01.02-.03.03-.04h0c1.09-1.4,3.11-1.65,4.51-.56.04.03.08.06.11.09l60.79,49.62,62.67-10.43,64.12-23.52,64.75-31.22,65.03-17.34,64.1,8.67,60.66-21.23c1.67-.59,3.5.29,4.09,1.97h0c.59,1.67-.29,3.5-1.97,4.09l-62.09,21.74-64.54-8.6-63.5,16.93-64.12,30.99-65.21,23.91-65.9,10.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 500.36,
    cy: 247.54,
    r: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 454.47,
    y: 277.42,
    width: 91.76,
    height: 24.9,
    rx: 3.56,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "466.38 293.59 462.73 295.51 463.42 291.44 460.46 288.55 464.56 287.95 466.38 284.25 468.21 287.95 472.3 288.55 469.34 291.44 470.04 295.51 466.38 293.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "483.38 293.59 479.73 295.51 480.42 291.44 477.46 288.55 481.55 287.95 483.38 284.25 485.21 287.95 489.3 288.55 486.34 291.44 487.03 295.51 483.38 293.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "500.38 293.59 496.7 295.51 497.42 291.44 494.46 288.55 498.53 287.95 500.38 284.25 502.2 287.95 506.27 288.55 503.31 291.44 504.03 295.51 500.38 293.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "517.35 293.59 513.7 295.51 514.39 291.44 511.43 288.55 515.52 287.95 517.35 284.25 519.18 287.95 523.27 288.55 520.31 291.44 521 295.51 517.35 293.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "534.35 293.59 530.69 295.51 531.39 291.44 528.43 288.55 532.52 287.95 534.35 284.25 536.17 287.95 540.27 288.55 537.31 291.44 538 295.51 534.35 293.59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500.35,
    cy: 343.96,
    r: 17.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 500.35,
    cy: 343.96,
    r: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 454.47,
    y: 373.85,
    width: 91.76,
    height: 24.9,
    rx: 3.56,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "466.38 389.99 462.73 391.91 463.42 387.84 460.46 384.98 464.56 384.37 466.38 380.67 468.21 384.37 472.3 384.98 469.34 387.84 470.04 391.91 466.38 389.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "483.38 389.99 479.73 391.91 480.42 387.84 477.46 384.98 481.55 384.37 483.38 380.67 485.21 384.37 489.3 384.98 486.34 387.84 487.03 391.91 483.38 389.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "500.38 389.99 496.7 391.91 497.42 387.84 494.46 384.98 498.53 384.37 500.38 380.67 502.2 384.37 506.27 384.98 503.31 387.84 504.03 391.91 500.38 389.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "517.35 389.99 513.7 391.91 514.39 387.84 511.43 384.98 515.52 384.37 517.35 380.67 519.18 384.37 523.27 384.98 520.31 387.84 521 391.91 517.35 389.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "534.35 389.99 530.69 391.91 531.39 387.84 528.43 384.98 532.52 384.37 534.35 380.67 536.17 384.37 540.27 384.98 537.31 387.84 538 391.91 534.35 389.99"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 500.35,
    cy: 440.39,
    r: 17.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 500.35,
    cy: 440.39,
    r: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 454.47,
    y: 470.26,
    width: 91.76,
    height: 24.9,
    rx: 3.56,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "466.38 486.42 462.73 488.34 463.42 484.27 460.46 481.4 464.56 480.8 466.38 477.1 468.21 480.8 472.3 481.4 469.34 484.27 470.04 488.34 466.38 486.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "483.38 486.42 479.73 488.34 480.42 484.27 477.46 481.4 481.55 480.8 483.38 477.1 485.21 480.8 489.3 481.4 486.34 484.27 487.03 488.34 483.38 486.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "500.38 486.42 496.7 488.34 497.42 484.27 494.46 481.4 498.53 480.8 500.38 477.1 502.2 480.8 506.27 481.4 503.31 484.27 504.03 488.34 500.38 486.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "517.35 486.42 513.7 488.34 514.39 484.27 511.43 481.4 515.52 480.8 517.35 477.1 519.18 480.8 523.27 481.4 520.31 484.27 521 488.34 517.35 486.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "534.35 486.42 530.69 488.34 531.39 484.27 528.43 481.4 532.52 480.8 534.35 477.1 536.17 480.8 540.27 481.4 537.31 484.27 538 488.34 534.35 486.42"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500.36,
    cy: 536.83,
    r: 17.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 500.36,
    cy: 536.83,
    r: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 454.47,
    y: 566.69,
    width: 91.76,
    height: 24.9,
    rx: 3.56,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "466.38 582.85 462.73 584.77 463.42 580.7 460.46 577.81 464.56 577.21 466.38 573.51 468.21 577.21 472.3 577.81 469.34 580.7 470.04 584.77 466.38 582.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "483.38 582.85 479.73 584.77 480.42 580.7 477.46 577.81 481.55 577.21 483.38 573.51 485.21 577.21 489.3 577.81 486.34 580.7 487.03 584.77 483.38 582.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "500.38 582.85 496.7 584.77 497.42 580.7 494.46 577.81 498.53 577.21 500.38 573.51 502.2 577.21 506.27 577.81 503.31 580.7 504.03 584.77 500.38 582.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "500.38 582.85 496.7 584.77 497.42 580.7 494.46 577.81 498.53 577.21 500.38 573.51 500.38 582.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "517.35 582.85 513.7 584.77 514.39 580.7 511.43 577.81 515.52 577.21 517.35 573.51 519.18 577.21 523.27 577.81 520.31 580.7 521 584.77 517.35 582.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "534.35 582.85 530.69 584.77 531.39 580.7 528.43 577.81 532.52 577.21 534.35 573.51 536.17 577.21 540.27 577.81 537.31 580.7 538 584.77 534.35 582.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 580.94,
    y: 552.49,
    width: 18.75,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 626.22,
    y: 538.94,
    width: 18.75,
    height: 49.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 671.47,
    y: 514.03,
    width: 18.75,
    height: 73.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.58,
    y: 532.12,
    width: 18.75,
    height: 55.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 648.83,
    y: 526.47,
    width: 18.75,
    height: 61.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 694.11,
    y: 527.93,
    width: 18.75,
    height: 60.05
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 603.58,
    y: 532.12,
    width: 18.75,
    height: 55.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 648.83,
    y: 526.47,
    width: 18.75,
    height: 61.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 694.11,
    y: 527.93,
    width: 18.75,
    height: 60.05
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 716.75,
    y: 506.91,
    width: 18.75,
    height: 81.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "915.83 587.98 761.27 587.98 771.74 552.49 793.27 532.12 815.91 563.45 838.55 526.47 861.19 551.01 883.82 527.93 906.46 506.91 915.83 506.91 915.83 587.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "915.83 587.98 761.27 587.98 771.74 564.28 793.27 546.85 815.91 563.45 838.55 544.16 861.19 551.01 883.82 545.62 906.46 536.39 915.83 506.91 915.83 587.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M980.14,471.09h37.67c-.52-20.81-17.8-37.26-38.61-36.75-20.09.5-36.25,16.66-36.75,36.75h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M980.14,471.09h37.67c-.52-20.81-17.8-37.26-38.61-36.75-20.09.5-36.25,16.66-36.75,36.75h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1006.82,444.45c-14.73-14.71-38.59-14.7-53.31.03-7.05,7.06-11.02,16.63-11.03,26.61h37.69l26.64-26.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.47,444.41l26.66,26.64v-37.69c-10,0-19.6,3.97-26.66,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M953.47,444.41l26.66,26.64v-37.69c-10,0-19.6,3.97-26.66,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M953.47,444.41l26.66,26.64v-37.69c-10,0-19.6,3.97-26.66,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.9,453.03l-2.71-2.73-17.04,17c-2.08-.57-4.23.66-4.8,2.74-.57,2.08.66,4.23,2.74,4.8.34.09.69.14,1.05.14,2.17,0,3.93-1.76,3.93-3.93h0c-.02-.35-.09-.69-.21-1.02l17.04-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M980.14,530.31h37.67c.52-20.81-15.94-38.1-36.75-38.61-20.81-.52-38.1,15.94-38.61,36.75-.02.62-.02,1.24,0,1.87h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M980.14,530.31h37.67c.52-20.81-15.94-38.1-36.75-38.61-20.81-.52-38.1,15.94-38.61,36.75-.02.62-.02,1.24,0,1.87h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1006.82,503.65c-14.73-14.71-38.59-14.7-53.31.03-7.06,7.07-11.03,16.65-11.03,26.64h37.69l26.64-26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M953.47,503.6l26.66,26.64v-37.76c-10.01,0-19.61,4.01-26.66,11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M953.47,503.6l26.66,26.64v-37.76c-10.01,0-19.61,4.01-26.66,11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.03,526.89v-21.9h-3.82v21.9c-1.24.66-2.02,1.95-2.03,3.35-.17,2.18,1.46,4.08,3.64,4.24,2.18.17,4.08-1.46,4.24-3.64.02-.2.02-.4,0-.6-.01-1.41-.79-2.69-2.03-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M980.14,589.6h37.67c-.52-20.81-17.8-37.26-38.61-36.75-20.09.5-36.25,16.66-36.75,36.75h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M980.14,589.6h37.67c-.52-20.81-17.8-37.26-38.61-36.75-20.09.5-36.25,16.66-36.75,36.75h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1006.82,562.87c-14.7-14.74-38.57-14.77-53.31-.07-7.12,7.1-11.1,16.75-11.07,26.8h37.69l26.69-26.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M953.47,562.83l26.66,26.64v-37.67c-10-.02-19.6,3.95-26.66,11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M953.47,562.83l26.66,26.64v-37.67c-10-.02-19.6,3.95-26.66,11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.9,571.45l-2.71-2.66-17.04,17.02c-2.07-.61-4.24.57-4.86,2.64-.61,2.07.57,4.24,2.64,4.86.39.12.8.17,1.2.16,2.17,0,3.93-1.76,3.93-3.93h0c-.02-.35-.09-.69-.21-1.02l17.04-17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1031.36,207.73l-25.32.28c-3.47.04-6.26,2.88-6.22,6.36h0s.23,21.18.23,21.18c.03,3.47,2.86,6.27,6.34,6.24h7.33l3.17,4.88c.75,1.28,2.39,1.7,3.67.95.39-.23.72-.56.95-.95l3.01-5.02h7.28c3.46-.01,6.26-2.83,6.24-6.29,0-.02,0-.05,0-.07l-.23-21.14c.09-3.46-2.64-6.34-6.1-6.43-.12,0-.23,0-.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1011.89,224.89c.43.2.79.51,1.04.9.25.4.37.87.37,1.34.01.52-.13,1.02-.42,1.46-.28.42-.67.75-1.13.95-.49.24-1.03.36-1.57.35-1.02.04-2.01-.34-2.73-1.06-.7-.85-1.04-1.93-.97-3.03,0-.8.18-1.59.53-2.31.33-.65.85-1.18,1.48-1.53.68-.35,1.43-.53,2.2-.51.43,0,.85.05,1.27.14.37.08.72.22,1.04.42l-.72,1.41c-.46-.29-1-.44-1.55-.42-.61-.03-1.21.19-1.66.6-.43.49-.66,1.13-.65,1.78.55-.51,1.29-.77,2.03-.72.49-.04.98.04,1.43.23ZM1011.05,228.12c.5-.46.53-1.23.07-1.73-.02-.02-.05-.05-.07-.07-.59-.48-1.44-.48-2.03,0-.27.21-.43.54-.42.88,0,.34.14.66.39.88.3.24.68.37,1.06.35.36.02.71-.09.99-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1015.7,229.37c-.55-.36-.98-.88-1.25-1.48-.34-.72-.5-1.52-.46-2.31-.03-.8.13-1.59.46-2.31.74-1.7,2.71-2.48,4.41-1.74.78.34,1.4.96,1.74,1.74.32.73.48,1.52.46,2.31.02.8-.13,1.59-.46,2.31-.79,1.72-2.83,2.47-4.54,1.67-.12-.06-.24-.12-.36-.19ZM1018.71,227.61c.58-1.28.58-2.75,0-4.02-.25-.41-.7-.65-1.18-.65-.48,0-.92.24-1.18.65-.56,1.28-.56,2.74,0,4.02.25.41.7.66,1.18.65.48.02.93-.23,1.18-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022.43,225.32c-.77-.98-.77-2.35,0-3.33.38-.41.92-.63,1.48-.6.56-.02,1.1.2,1.48.6.74.99.74,2.34,0,3.33-.38.41-.92.63-1.48.6-.56.03-1.1-.19-1.48-.6ZM1024.54,224.63c.31-.61.31-1.33,0-1.94-.22-.34-.68-.45-1.02-.23-.09.06-.17.14-.23.23-.31.61-.31,1.33,0,1.94.22.34.68.45,1.02.23.09-.06.17-.14.23-.23ZM1028.81,221.49h1.41l-5.64,8.26h-1.39l5.62-8.26ZM1028.44,229.56c-.33-.15-.61-.39-.81-.69-.17-.38-.26-.79-.25-1.2,0-.41.08-.82.25-1.2.16-.33.41-.6.72-.79.32-.19.69-.28,1.06-.28.56-.02,1.1.21,1.48.62.4.45.61,1.04.58,1.64.03.61-.17,1.21-.58,1.66-.38.42-.92.65-1.48.62-.35-.05-.69-.18-.97-.39ZM1030.13,228.52c.18-.29.26-.63.23-.97.02-.34-.06-.68-.23-.97-.24-.34-.72-.43-1.06-.19-.07.05-.13.11-.19.19-.17.29-.25.63-.23.97-.03.35.05.69.23.99.14.2.38.32.62.32.26.01.5-.12.62-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006.48,318.52l25.32-.28c3.47-.04,6.26-2.88,6.22-6.36h0s-.23-21.21-.23-21.21c-.03-3.46-2.85-6.25-6.31-6.22,0,0-.02,0-.02,0h-7.33l-3.17-4.72c-.73-1.28-2.35-1.72-3.63-1-.42.24-.76.58-1,1l-3.01,5.02h-7.28c-3.46.01-6.26,2.83-6.24,6.29,0,.02,0,.05,0,.07l.21,21.14c.02,3.49,2.87,6.29,6.36,6.27.04,0,.08,0,.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1012.14,302.86c.55.46.86,1.15.83,1.87,0,.48-.14.96-.39,1.36-.27.43-.67.78-1.13.99-.61.26-1.26.38-1.92.37-.58,0-1.15-.08-1.71-.23-.51-.14-.99-.35-1.43-.65l.76-1.48c.32.25.69.44,1.09.55.4.13.82.19,1.25.18.4.02.79-.08,1.13-.28.27-.17.43-.47.42-.79.01-.33-.16-.64-.44-.81-.47-.2-.97-.29-1.48-.25h-2.1l.42-4.62h5.04v1.46h-3.33l-.14,1.57h.67c.88-.04,1.75.22,2.47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1015.45,306.84c-.55-.36-.98-.88-1.25-1.48-.33-.73-.49-1.52-.46-2.31-.02-.8.14-1.59.46-2.31.26-.6.69-1.11,1.25-1.46.55-.34,1.18-.52,1.83-.51.65-.02,1.28.16,1.83.51.55.35,1,.86,1.27,1.46.32.73.47,1.52.44,2.31.03.79-.12,1.58-.44,2.31-.28.6-.72,1.11-1.27,1.48-.54.35-1.18.53-1.83.51-.65.01-1.28-.16-1.83-.51ZM1018.39,305.17c.34-.61.49-1.31.44-2.01.06-.69-.1-1.38-.44-1.99-.38-.64-1.2-.85-1.84-.48-.2.12-.36.28-.48.48-.34.6-.5,1.3-.44,1.99-.05.7.1,1.4.44,2.01.42.64,1.28.81,1.92.39.15-.1.29-.23.39-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022.18,302.86c-.77-.98-.77-2.35,0-3.33.39-.4.92-.61,1.48-.6.56-.02,1.09.2,1.48.6.74.99.74,2.34,0,3.33-.38.41-.92.63-1.48.6-.56.02-1.1-.2-1.48-.6ZM1024.28,302.17c.31-.61.31-1.33,0-1.94-.12-.23-.37-.36-.62-.35-.25,0-.49.13-.62.35-.31.61-.31,1.33,0,1.94.13.22.37.35.62.35.27,0,.52-.16.62-.42v.07ZM1028.58,299.02h1.36l-5.64,8.26h-1.29l5.57-8.26ZM1028.21,307.09c-.32-.19-.58-.47-.74-.81-.17-.38-.26-.79-.25-1.2,0-.41.08-.82.25-1.2.16-.33.42-.6.74-.79.31-.19.67-.28,1.04-.28.56-.02,1.11.2,1.48.62.4.45.61,1.04.58,1.64.03.61-.17,1.21-.58,1.66-.37.42-.92.65-1.48.62-.37-.01-.73-.13-1.04-.35v.07ZM1029.9,306.05c.17-.29.25-.63.23-.97.01-.34-.07-.67-.23-.97-.15-.21-.39-.33-.65-.32-.25,0-.48.12-.62.32-.17.29-.25.63-.23.97-.03.35.05.69.23.99.14.2.38.32.62.32.29.01.57-.15.69-.42l-.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765.75,464.01c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h94.07c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765.75,485.94c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h75.73c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-75.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765.75,474.98c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h68.01c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-68.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M765.75,464.01c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h94.07c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M765.75,485.94c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h75.73c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-75.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M765.75,474.98c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h68.01c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-68.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.97,464.01c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h94.07c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.97,485.94c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h55.17c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-55.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.97,474.98c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h79.8c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-79.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M583.97,464.01c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h94.07c1.68-.15,3.16,1.1,3.31,2.78.15,1.68-1.1,3.16-2.78,3.31-.18.02-.35.02-.53,0h-94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M583.97,485.94c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h55.17c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-55.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M583.97,474.98c-1.68-.15-2.92-1.63-2.78-3.31.13-1.48,1.3-2.65,2.78-2.78h79.8c1.68.15,2.92,1.63,2.78,3.31-.13,1.48-1.3,2.65-2.78,2.78h-79.8Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M984.44,487.56h-40.19c-2.03-.03-3.71-1.57-3.93-3.58l-5.18-59.87c-.2-1.78,1.07-3.38,2.85-3.59.15-.02.29-.02.44-.02h40.19c2.03.05,3.71,1.59,3.93,3.61l5.23,59.87c.19,1.78-1.09,3.37-2.87,3.57-.15.02-.31.02-.46.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M986.75,487.56h-40.19c-2.03-.03-3.71-1.57-3.93-3.58l-5.18-59.87c-.2-1.78,1.07-3.38,2.85-3.59.15-.02.29-.02.44-.02h40.19c2.03.05,3.71,1.59,3.93,3.61l5.23,59.87c.19,1.78-1.09,3.37-2.87,3.57-.15.02-.31.02-.46.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M986.75,487.56h-40.19c-2.03-.03-3.71-1.57-3.93-3.58l-5.18-59.87c-.2-1.78,1.07-3.38,2.85-3.59.15-.02.29-.02.44-.02h40.19c2.03.05,3.71,1.59,3.93,3.61l5.23,59.87c.19,1.78-1.09,3.37-2.87,3.57-.15.02-.31.02-.46.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M981.09,422.81h-40.19c-.64-.02-1.17.49-1.19,1.12,0,.06,0,.11,0,.17l5.23,59.87c.08.72.69,1.26,1.41,1.27h40.19c.64.02,1.17-.49,1.18-1.13,0-.05,0-.1,0-.14l-5.23-59.87c-.08-.72-.68-1.28-1.41-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M987.72,483.97l-5.16-59.06-37.11,59.98c.25.22.57.34.9.35h40.19c.64.02,1.17-.49,1.18-1.13,0-.05,0-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M974.77,454.02h-20.81c-1.32-.02-2.43-1-2.61-2.31l-1.06-12.28c-.09-1.18.8-2.22,1.98-2.31.06,0,.13,0,.19,0h20.81c1.32.02,2.43,1,2.61,2.31l1.06,12.28c.09,1.18-.8,2.22-1.98,2.31-.06,0-.13,0-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M976.62,475.42h-20.81c-1.32-.02-2.43-1-2.61-2.31l-1.06-12.28c-.09-1.18.8-2.22,1.98-2.31.06,0,.13,0,.19,0h20.81c1.32.02,2.43,1,2.61,2.31l1.06,12.28c.09,1.18-.8,2.22-1.98,2.31-.06,0-.13,0-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.28,441.86c-.4,0-.74-.32-.79-.72-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h16.72c.42,0,.76.33.81.74.03.37-.25.69-.62.72-.02,0-.03,0-.05,0h-16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.75,447.16c-.41-.01-.75-.33-.79-.74-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h13.87c.42,0,.76.33.81.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.52,444.52c-.41-.02-.74-.33-.79-.74-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h11.05c.41.01.75.33.79.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-11.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M954.28,441.86c-.4,0-.74-.32-.79-.72-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h16.72c.42,0,.76.33.81.74.03.37-.25.69-.62.72-.02,0-.03,0-.05,0h-16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M954.75,447.16c-.41-.01-.75-.33-.79-.74-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h13.87c.42,0,.76.33.81.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M954.52,444.52c-.41-.02-.74-.33-.79-.74-.04-.37.23-.7.6-.74.02,0,.05,0,.07,0h11.05c.41.01.75.33.79.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-11.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M956.2,463.58c-.42,0-.76-.33-.81-.74-.03-.38.26-.71.65-.74,0,0,.02,0,.03,0h16.72c.42,0,.76.33.81.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M956.43,466.21c-.42,0-.76-.33-.81-.74-.03-.37.25-.69.62-.72.02,0,.03,0,.05,0h11.05c.4,0,.74.32.79.72.05.35-.19.68-.55.73-.04,0-.08,0-.12,0h-11.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M956.2,463.58c-.42,0-.76-.33-.81-.74-.03-.38.26-.71.65-.74,0,0,.02,0,.03,0h16.72c.42,0,.76.33.81.74.04.37-.23.7-.6.74-.02,0-.05,0-.07,0h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M956.43,466.21c-.42,0-.76-.33-.81-.74-.03-.37.25-.69.62-.72.02,0,.03,0,.05,0h11.05c.4,0,.74.32.79.72.05.35-.19.68-.55.73-.04,0-.08,0-.12,0h-11.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1020.4,384.37c.37-1.34,0-2.64-.9-2.89s-1.9.65-2.31,1.99,0,2.61.88,2.87,1.94-.62,2.34-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1018.64,386.39l-10.22,6.66c1.56,2.42,4.18,3.95,7.05,4.14l3.17-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1066.14,398.9c-6.94,16.19-9.41,23.12-20.81,28.72-15.79,4.12-35.45-3.63-33.58-21.53,1.71-16.19,12.6-39.8,31.15-40.77,13.24-.62,24.48,9.61,25.1,22.85.17,3.68-.5,7.35-1.98,10.72h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1023.63,381.88c-.26-.08-.46-.28-.55-.53-.56-1.99-2.04-3.6-3.98-4.32-.43-.13-.68-.58-.55-1.02s.58-.68,1.02-.55c2.47.87,4.37,2.89,5.09,5.41.14.41-.06.86-.46,1.02h0c-.18.07-.38.07-.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1028.44,420.01s-11.77,2.31-16.42-7.89c1.6,8.23,8.44,13.5,16.7,15.56l2.82-1.99-1.53-4.19-1.57-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1049.81,446.83s-10.15-4.97-2.82-24.35c0,0-8.12-8.05-16.56-4.62-8.44,3.42-1.36,21.25-11.28,24,0,0,5.18,7.19,30.66,4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1019.96,381.76c-1.04-.27-1.93-.94-2.47-1.87.17,1.17.99,2.14,2.1,2.52l.37-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1014.32,442.67s6.06-9.46,22.38-7.58c16.33,1.87,13.11,11.75,13.11,11.75l-35.5-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1014.32,442.67s6.06-9.46,22.38-7.58c16.33,1.87,13.11,11.75,13.11,11.75l-35.5-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1027.47,394.5c.31-4.79,1.91-9.41,4.62-13.37,4.62-6.94,2.03-11.45,2.31-15.84s22.82-8.83,31.5,6.2c0,0,15.61,13.48,4.62,29.67-10.98,16.19-15.42,28.56-28.72,26.52-13.3-2.03-5.67-24.03-14.34-33.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1065.97,371.49c-3.67-6.02-10.07-9.86-17.11-10.24-3.45,7.68,5.67,16.19,5.67,16.19,0,0-13.37,3.31-11.24,14.27,2.13,10.96,17.71,5.18,17.71,5.18,0,0-9.83,9.53-2.64,15.15,1.23,1.08,2.89,1.51,4.49,1.16,2.31-3.61,4.79-7.65,7.75-12.02,10.98-16.19-4.62-29.67-4.62-29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1065.97,371.49c-.94-1.62-2.11-3.09-3.47-4.37-6.31,3.22-10.29,9.7-10.29,16.79,0,15.59,13.87,18.5,17.34,18.8l1.04-1.55c10.98-16.19-4.62-29.67-4.62-29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1028.58,389.42c-2.91,2.09-4.88,5.25-5.48,8.79-.74,4.62,3.61,6.54,7.77,4.81,3.77-1.57,8.63-5.9,7.47-10.43-.86-3.26-4.21-5.2-7.46-4.34-.84.22-1.62.62-2.29,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.22,378.69s-12-13.34-1.97-21.07c8.09-6.22,14.34,9.55,14.34,9.55,0,0-1.32-17.64,11.1-15.61,12.42,2.03,4.93,17.34,4.93,17.34,0,0,10.98-6.94,15.61.58,4.62,7.52-8.83,12.46-8.83,12.46,0,0,15.19,8.95,7.95,15.15-7.24,6.2-14.15-1.2-14.15-1.2,0,0,4.32,12.02-3.77,13.87-7.33,1.71-9.53-9.41-9.53-9.41,0,0-5.5,13.3-12.14,8.09-6.64-5.2.28-13.99.28-13.99,0,0-12.23,5.32-14.22-4.79s10.41-10.98,10.41-10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1081.1,485.01s21.99,47.24,11.4,51.54c-10.59,4.3-42.9,11.56-42.9,11.56l-15.56,5.62-9.02-5.85,2.31-15.17,22.75,4.97,27.31-12.23-12.9-28.72,16.6-11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1070.6,459.64c.57-.62,1.54-.66,2.16-.09.16.14.28.32.36.51,5.04,11.68,28.74,67.75,22.13,75.92-4.93,6.06-28.72,9.25-28.72,9.25l-5.06-13.6,14.43-6.64-16.19-37s-1.76-14.15,10.89-28.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1059.66,487.99l8.65,19.73c7.17-42.64,2.31-48.08,2.31-48.08-12.67,14.2-10.96,28.35-10.96,28.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1063.04 864.44 1075.43 906.59 1088.01 905.85 1085.35 860.09 1063.04 864.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M997.78,552.3s-15.29,30.76-.58,87.32c14.71,56.56,73.56,253.6,73.56,253.6l16.58-1.99s1.04-70.71-22.27-127.76c0,0-11.19-97.01-5.76-119.81,3.82-15.93,6.13-29.25-.44-53.42-2.58-10.33-6.14-20.4-10.61-30.06-4.32-8.63-3.05-11.96-3.05-11.96l-47.43,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1070.76,893.23l16.58-1.99v-7.52l-18.5,2.52,1.92,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1017.37,711.7c21.27-59.08,15.42-101.96,15.42-101.96l-13.3-1.73-10.41,18.5-7.26,30.32c4.12,14.96,9.62,34.04,15.54,54.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1075.11,905.39l14.96-2.1c.65-.08,1.27.31,1.48.92l7.15,13.67c.44,1.2-.17,2.53-1.37,2.97-.01,0-.03,0-.04.01-.15.06-.3.1-.46.12-6.24.65-11.82.97-19.59,1.92-9.13,1.11-6.68,1.94-17.41,3.38-6.47.88-8.56-6.34-5.85-6.94,12.39-3.12,13.23-7.08,17.53-12.16.94-1.02,2.23-1.65,3.61-1.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1067.11 890.17 1090.09 887.28 1089.72 894.13 1069.47 896.63 1067.11 890.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "999.52 867.28 1004.93 909.3 1017.65 909.3 1020.93 868.07 999.52 867.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M977.57,547.59c-.5,3.81-1.56,7.52-3.12,11.03-9.63,23.88-12.92,49.84-9.57,75.36,6.75,58.07,37.81,261.31,37.81,261.31h16.72s11.45-69.1-2.08-129.94c0,0-4.79-85.56,2.31-108.01,4.95-15.54,19.01-30.59,15.4-63.43-3.61-32.84-12.33-44.1-12.33-44.1l-45.14-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1001.55,887.77l1.16,7.56h16.72s.44-2.75,1.06-7.56h-18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.65,907.98l14.89.32c.64,0,1.2.46,1.32,1.09l2.87,14.06c.26,1.24-.54,2.46-1.78,2.73h-.49c-6.2-.23-11.7-.67-19.42-.79-9.11-.16-6.82.95-17.53.92-6.45,0-7.49-7.4-4.74-7.7,12.53-1.36,16.19-5.11,21.14-9.5,1.07-.81,2.4-1.22,3.75-1.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "999.52 891.79 1022.69 891.79 1021.39 898.52 1000.95 898.52 999.52 891.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1059.41,576.72c-23.73-32.65,17.62-105.22,12.79-118.79-4.83-13.57-80.15-36.14-90.05,2.31-9.9,38.46-4.62,64.75-6.13,81.51-2.17,24.56-12.3,34.39-12.3,34.39,0,0,52.35,19.66,95.69.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.92,490.17c-.99,11.27-1.25,22.6-.79,33.9,28-32.37,21.81-63.2,21.81-63.2l-2.31,1.43-10.13,8.39s-3.98,8.58-8.58,19.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M933.24,485.27s7.84,40.93,16.79,48.03,39.89-43.5,39.89-43.5l-15.29-9.25-21.21,28.49-12.51-29.34,2.47-15.63-4.07-9.6c-.9-1.62-2.94-2.2-4.56-1.3-.63.35-1.13.9-1.43,1.56l-4.62,10.24c-.97,2.14-1.07,4.57-.28,6.78l4.81,13.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M953.41,506.56l-7.31-17.74-9.78,14.48s4.86,34.5,17.3,31.29c11.86-3.05,38.69-43.45,44.51-59.01,5.83-15.56-2.06-30.73-2.06-30.73,0,0-9.5-2.47-21.74,26.22-10.52,24.65-20.93,35.5-20.93,35.5Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.91,428.15c-2.35-1.93-5.81-1.6-7.75.74-.22.27-.41.55-.58.85-9.39,16.9-36.35,68.01-27.75,82.23,10.36,17.14,59.45,15.75,59.45,15.75l2.31-14.52-31.52-16.3s9.71-19.38,12.67-25.97c4.58-10.13,11.35-27.4-6.84-42.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M445.13,496.9s9.71-19.38,12.67-25.97c3.28-7.33,7.72-18.36,3.08-29.74l-8.05-8.53-7.7,2.43s-15.61,75.27,0,90.72c5.36.83,10.66,1.32,15.24,1.6,5.5-3.19,9.5-10.08,12.16-16.19l-27.4-14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.05,356.93c-.42-1.5,0-2.98,1.02-3.26s2.17.72,2.61,2.31,0,2.98-1.02,3.28c-1.02.3-2.17-.9-2.61-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M499.06,359.26l11.56,7.47c-1.8,2.72-4.79,4.44-8.05,4.62l-3.51-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M444.9,373.51c7.82,18.5,10.73,26.45,23.68,32.77,18.04,4.62,40.44-4.14,38.29-24.58-1.92-18.36-14.36-45.39-35.52-46.48-15.09-.77-27.95,10.84-28.72,25.92-.22,4.24.56,8.48,2.26,12.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.46,354.1c.29-.09.53-.31.65-.6.64-2.31,2.37-4.16,4.62-4.95.48-.15.76-.65.62-1.13-.16-.49-.66-.77-1.16-.65-2.81.99-4.97,3.28-5.8,6.15-.17.48.08,1.01.55,1.18h0c.17.05.34.05.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M487.87,397.67s13.41,2.73,18.73-9c-1.8,9.39-9.62,15.4-19.03,17.74l-3.24-2.31,1.73-4.79,1.8-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M461.87,432.13s12.95-6.34,3.63-31.03c0,0,10.34-10.24,21.07-5.9,10.73,4.35,1.73,27.08,14.38,30.59,0,0-6.61,9.13-39.08,6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.32,419.69s-2.31-8.39,12.05-11.91c14.36-3.51,26.32.79,28.21,7.1,1.9,6.31-40.26,4.81-40.26,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M464.32,419.69s-2.31-8.39,12.05-11.91c14.36-3.51,26.32.79,28.21,7.1,1.9,6.31-40.26,4.81-40.26,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.46,368.97c2.28-1.75,2.71-5.02.96-7.3-.28-.36-.6-.68-.96-.96-4.62-4.32-11.56-8-9.6-13.99,1.97-5.99-7.21-10.08-7.21-10.08,0,0,9.04-5.9,3.75-10.61-5.3-4.72-7.72,4.12-20.44,9.25-14.66,5.78-31.06,19.73-21.04,38.02,10.01,18.29,18.87,33.6,30.87,30.66,12-2.94,17.69-26.15,17.69-26.15l5.99-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M490.06,362.71c3.33,2.37,5.58,5.98,6.24,10.01.86,5.36-4.12,7.47-8.86,5.48-4.28-1.78-9.85-6.73-8.51-11.89.97-3.71,4.75-5.93,8.46-4.97.98.25,1.88.72,2.66,1.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "518.27 877.43 522.83 908.28 541.38 907.59 542.79 875.67 518.27 877.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.36,905.39l-18.29.39c-.8.02-1.48.58-1.64,1.36l-3.49,17.25c-.33,1.52.64,3.02,2.17,3.35,0,0,0,0,0,0,.2.02.4.02.6,0,7.61-.25,14.38-.81,23.86-.97,11.19-.18,8.37,1.2,21.53,1.16,7.93,0,9.25-9.09,5.85-9.48-15.42-1.64-19.93-6.27-25.97-11.56-1.31-1.04-2.95-1.58-4.62-1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "427.81 877.43 426.61 904.77 445.87 907.29 452.32 875.67 427.81 877.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.76,902.34l-18.27-1.16c-.79-.04-1.51.46-1.73,1.23l-4.95,16.9c-.44,1.49.41,3.06,1.9,3.51.2.02.4.02.6,0,7.61.37,14.38.39,23.86,1.04,11.17.72,8.23,1.87,21.37,2.94,7.89.62,9.94-8.28,6.61-8.95-15.24-2.94-19.36-7.91-24.9-13.87-1.25-1.06-2.84-1.64-4.49-1.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "471.98 513.96 483.33 516.69 502.53 511.84 505.63 520.3 508.01 532.19 492.74 534.8 480.19 527.24 464.19 526.91 471.98 513.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.9,431.25l9.25,131.65,100.64.79s12.28-36.35-2.89-87.87l-14.82-49.67c-1.25-4.18-4.6-7.4-8.83-8.46-14.92-3.68-51.2-8.07-79.5,6.54-2.56,1.37-4.07,4.13-3.84,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M451.95,563.94c-5.64,26.08-7.12,44.38-6.94,56.59,0,4.32.25,7.89.55,10.75.95,8.65,1.18,17.37.67,26.06l-.14,2.31c-1.55,25.07-1.83,50.67-1.78,67.55v.35c.05,11.05-1.68,22.04-5.13,32.54-.53,1.62-1.06,3.31-1.55,4.99-14.22,48.79-13.02,126.63-13.02,126.63l27.61,1.55,75.92-334.1h-70.55c-2.78.06-5.13,2.06-5.64,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M493.21,614.53l-9.46-2.17-5.83-7.08s.6,52.89,15.93,104.41l14.94-65.72-15.59-29.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "422.1 886.27 422.49 894.38 453.9 895.68 455.31 887.42 422.1 886.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "422.1 886.27 422.49 894.38 453.9 895.68 455.31 887.42 422.1 886.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M479.59,559.15c-6.45,38.62-2.47,60.63,1.8,72.15.42,1.11.83,2.15,1.25,3.08,3.17,6.98,5.29,14.39,6.31,21.99,0,.35,0,.72.16,1.09,3.85,26.55,9.25,52.85,16.19,78.76v.25c2.05,7.65,2.57,15.64,1.53,23.49-.35,2.57-.62,5.32-.81,8.21-3.05,44.95,11.72,126.91,11.72,126.91l27.15-2.54,11.82-329.52c.12-2.04-1.44-3.79-3.48-3.9-.03,0-.05,0-.08,0l-73.56.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "514.39 890.94 516.7 898.87 547.06 896.23 547.5 887.88 514.39 890.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "514.39 890.94 516.7 898.87 547.06 896.23 547.5 887.88 514.39 890.94"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480.21,
    y: 564.77,
    width: 50.99,
    height: 7.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "473.48 564.77 453.9 564.77 452.83 571.84 473.48 571.84 473.48 564.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 538.09,
    y: 564.77,
    width: 15.54,
    height: 7.08
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.97,475.81l-8-26.82-5.48-7.63-7.08-5.43-3.26,8.26c2.67,17.9,12.49,33.96,27.22,44.49-1.02-4.16-2.1-8.44-3.4-12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M599.97,431.2l4.88-10.61-.86-16.49c-.12-2.11.59-4.18,1.97-5.78l2.82-3.26c2.95-3.43,8.11-3.82,11.54-.87.31.27.61.56.87.87l1.62,1.9c1.32,1.53,2.01,3.51,1.94,5.53l-.23,9.25c-.05,1.96-.81,3.84-2.13,5.3l-7.79,8.58-3.42,15.66-11.22-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.68,420.17l47.5,38.22,16.58-32.1,14.27,5.94s-10.15,57.02-23.12,57.95c-12.97.92-45.49-14.48-58.85-32.77-9.74-13.3-5.32-28.51-2.17-35.82.84-1.91,3.06-2.78,4.96-1.94.3.13.58.3.84.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectivePerformanceEvaluation);
export default __webpack_public_path__ + "static/media/objective-performance-evaluation.59d9ece2cf4aea890ed4b972eeedbbb5.svg";
export { ForwardRef as ReactComponent };